export default __webpack_public_path__ + "static/media/doge.dfd15f2b.png";